define('responsive-gameday/views/Monitor/ViewModels/distributors/WrapupViewDistributor',['require','exports','module','GameDayCore','../../Events/ViewModelUpdateEvents','responsive-gameday/utils/ui-log','message-service/message-service','gameday-index-url-hasher/UrlHasher','GameDayCore/GDModel/enums/datasources/Datasources','gameday-resource-path/gameday-resource-path'],function(require,exports,module) {
	var GDC = require("GameDayCore"),
		UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        uilog = require( 'responsive-gameday/utils/ui-log' ),
		MessageService = require("message-service/message-service"),
		UrlHasher = require( "gameday-index-url-hasher/UrlHasher" ),
		Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
		resourcePath = require("gameday-resource-path/gameday-resource-path");

	var gameData = {};
	/*
	 * "What the fuck is this bullshit?!" ~ You might be asking yourself this.. Well, I'll explain.
	 * This is used to keep the wrapup headline from linking to an article when looking at a game prior to 2015. Why would
	 * we want to do that? Because content ids for league recaps in gamecenter.xml are invalid. They aren't linking to
	 * articles. Just 404 pages. Sweet.
	 */
	function isAtLeast2015(linescore) {
		return parseInt(linescore.id.substr(0, 4)) >= 2015;
	}

	function buildSendData(){

		gameData = GDC.getGameData();
		var gid = UrlHasher.getHashParams().game;
		
		var dataPack = self.dataPack || {},
			game,
			gamecenter,
			that = self,
			linescore,
			seriesLabel = "series",
			seriesRecord,
			gidInfo = gid.split("_");

		// Ensure that each set of data exists
		switch (undefined) {
			case gameData.game:
			case gameData.gamecenter:
				uilog.warn("missing a key piece of data for drawing Wrapup View");
				// return;

			default:
				game = gameData.game;
				gamecenter = gameData.gamecenter || {};
				linescore = gameData.linescore;
		}

		var domain = window.location.hostname.indexOf("beta") >= 0 ? 'http://beta.mlb.com' : 'http://mlb.mlb.com';

		dataPack.recap = {};

		dataPack.recap.game = {
			headline: gamecenter.league_articles && gamecenter.league_articles.wrap && gamecenter.league_articles.wrap.headline || '',
			blurb: gamecenter.league_articles && gamecenter.league_articles.wrap && gamecenter.league_articles.wrap.blurb || '',
			hasBlurb: gamecenter.league_articles && gamecenter.league_articles.wrap && gamecenter.league_articles.wrap.blurb !== '',
			url: gamecenter.league_articles && gamecenter.league_articles.recap && gamecenter.league_articles.recap.url && gamecenter.league_articles.recap.url.cid && isAtLeast2015(linescore) ? 'http://m.mlb.com/news/article/' + gamecenter.league_articles.recap.url.cid + "?game_pk=" + linescore.game_pk : undefined,
			photo: gamecenter.photos && gamecenter.photos.url ? domain + (gamecenter.photos.url_retina || gamecenter.photos.url) : '',
			gamePk: game.game_pk,
			photosLink: 'http://mlb.mlb.com/photos/gallery.jsp?gid=' + gid + '&c_id=' + game.home.file_code,
			isAtLeast2015: isAtLeast2015(linescore)
		};

		dataPack.recap.recaps_available = !!(dataPack.recap.headline || dataPack.recap.blurb);

		MessageService.one.call(that, GDC.requestGameData(Datasources.WRAPUPVIDEOLIST, {
			gamePk: game.game_pk
		}), function(payload, evt) {
			var videoSource = payload.wrapupVideoList && payload.wrapupVideoList.videos;
			if(videoSource) {
				if(videoSource.length >= 1) {
					dataPack.videoSlideOne = {
						videos: videoSource.slice(0,3)
					};
				}
				if(videoSource.length >= 4) {
					dataPack.videoSlideTwo = {
						videos: videoSource.slice(3,6)
					};
				}
				if(videoSource.length >= 7) {
					dataPack.videoSlideThree = {
						videos: videoSource.slice(6,9)
					}
				}
				if(videoSource.length >= 10) {
					dataPack.videoSlideFour = {
						videos: videoSource.slice(9,12)
					}
				}
				dataPack.videoSlides = videoSource.slice(0,12);
				// dataPack.recap.thumb = dataPack.videoSlides.thumb = "http://mlb.mlb.com/images/gameday/wrap/highlight-thumbnail@2x.png"
			} else {
				// dataPack.videoSlides = [];
			};

            
            MessageService.one.call(that, GDC.requestGameData(Datasources.CONDENSEDGAME, {
                        gid: "gid_" +gid,
                        yyyy: gidInfo[0],
                        mm: gidInfo[1],
                        dd: gidInfo[2],
                        sportcode: gidInfo[4].substr(3,6)
                    }), function(condensed, evt) {

              dataPack.recap.game.condensedGame = (condensed && condensed.condensedGame && condensed.condensedGame.video && condensed.condensedGame.video.id) ? resourcePath.get('condensedGameLink',{ cid : condensed.condensedGame.video.id, gid: game.game_pk}) : "";
              
              MessageService.one.call(that, GDC.requestGameData(Datasources.WRAPUPARTICLELIST, {gamePk: game.game_pk}), function(payload, evt) {
				dataPack.moreStoriesLink =  payload.wrapupArticleList && payload.wrapupArticleList.articles && payload.wrapupArticleList.articles[0].url + "&game_pk=" + payload.wrapupArticleList.articles[0].itemTags.game_pk;
				dataPack.articleList = payload.wrapupArticleList && payload.wrapupArticleList.articles && payload.wrapupArticleList.articles.slice(0, 4);
				dataPack.articleList2 = payload.wrapupArticleList && payload.wrapupArticleList.articles && payload.wrapupArticleList.articles.slice(4, 8);
				dataPack.videoList = videoSource;
				dataPack.enoughRelatedContentExists = !!(videoSource || dataPack.articleList);
				MessageService.publish(UpdateEvents.UPDATE_WRAPUP, dataPack);
			  });
			
            });
			
		});
	}

	exports.setGameData = function(game, scenes) {
		gameData = game || gameData;

		var liveState = UrlHasher.getHashParams().game_state;

		// If it's wrap, dispatch data. If its not, only dispatch when requested.
		if(liveState == "Wrapup"){
			this.prepareForDispatch();
		}

		MessageService.off(UpdateEvents.REQUEST_WRAPUP_DATA, exports.handleUpdateRequest);
		MessageService.on.call(this, UpdateEvents.REQUEST_WRAPUP_DATA, exports.handleUpdateRequest);
	};


	exports.prepareForDispatch = function() {
		if(gameData.linescore.game_pk !== GDC.getGameData().linescore.game_pk) {
			// wrong game, wait for further updates
			return;
		}

		MessageService.one.call(this,GDC.requestGameData(Datasources.GAMECENTER),buildSendData);
	};

	exports.handleUpdateRequest = function() {
		gameData = GDC.getGameData();
		this.prepareForDispatch();
	}

});
